// This file is automatically generated. Runtime URL/key selection is local-safe.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { config } from "@/lib/config";

const SUPABASE_URL = config.supabaseUrl;
const SUPABASE_PUBLISHABLE_KEY = config.supabasePublishableKey;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  // Surface a clear local/dev error instead of failing later with unclear Supabase errors.
  console.warn("Supabase URL or publishable key is missing.");
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
